import { getVivaConnectionsAppTheme, isInVivaConnectionsApp } from 'vivaConnections';

type IsInvertedTheme = () => boolean;
export const isInvertedTheme: IsInvertedTheme = () => {
  if (!isInVivaConnectionsApp()) {
    //TODO: Read theme from Teams context and return whether theme is dark
    return false;
  }
  const theme = getVivaConnectionsAppTheme();
  if (theme === undefined) {
    return false;
  }

  return theme === 'dark';
};
